import { motion } from "framer-motion";
import { Building2, Briefcase, Users, Wrench, LineChart, KeyRound, Wallet } from "lucide-react";
import { SERVICES } from "../../lib/content";

const ICONS = { Building2, Briefcase, Users, Wrench, LineChart, KeyRound, Wallet };

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <span className="overline">What we do</span>
          <h2 className="font-serif-display text-[#FDFBF7] text-3xl md:text-5xl tracking-tight mt-4 leading-tight">
            A complete management discipline
          </h2>
          <p className="text-[#A3B1A8] mt-5 text-base md:text-lg leading-relaxed">
            Every service is delivered to one standard, the highest. From a single home to a growing residential
            portfolio, your investment is protected end to end.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: "easeOut" }}
                data-testid={`service-card-${i}`}
                className="group p-8 rounded-2xl bg-[#0F2119] border border-white/5 hover:border-[#D4AF37]/50 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center mb-6 group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                  <Icon size={22} className="text-[#D4AF37]" />
                </div>
                <h3 className="font-serif-display text-[#FDFBF7] text-xl mb-3">{s.title}</h3>
                <p className="text-[#A3B1A8] text-sm leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
